import { Box, Grid, Paper} from "@mui/material";
import InfoCard from "../InfoCard";

export default function VendorRevenue({data}) {
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate >
        <Grid container columnSpacing={4} rowSpacing={2} >
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <InfoCard title='Walk-In Revenue' value={parseFloat(data['walkInBookingRevenue'] || 0).toFixed(2)} theme='deepOrange' />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <InfoCard title='Online Revenue' value={parseFloat(data['onlineBookingRevenue'] || 0).toFixed(2)} theme='teal' />
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
